import { ClickEvent, LookupModelSearchEvent, Switch } from "@mcleod/components";
import { AutogenLayoutOrderControl } from "./autogen/AutogenLayoutOrderControl";
import { LMECompanySettings } from "@mcleod/general";

export class OrderControl extends AutogenLayoutOrderControl {
    override onLoad(): void | Promise<void> {
        //Do not use autoSearch to avoid issues with Child DataSources with null Join Conditions
        this.mainDataSource.search().then(() => {
            this.manageAllowBatchOrderChecked(this.activeRow.getBoolean("allow_batch_entry"));
        });
        this.setDefaultValues();

        const company = LMECompanySettings.getSingleton();
        this.tabBatchOrder.visible = !company.isBrokerageOnly() && !company.isBrokerageLtl();
    }

    private setDefaultValues(): void {
        this.textboxBreadcrumbInterval.text = "30";
    }

    textboxDeliveryReceiptFormatBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.document_type = "R";
        event.filter.template_number = ">0";
    }

    manageAllowBatchOrderChecked(isChecked: boolean) {
        this.switchBatchCreateEmpties.enabled = isChecked;
        if (!isChecked) {
            this.switchBatchCreateEmpties.checked = false;
        }
    }

    switchAllowBatchOrderEntryOnClick(event: ClickEvent) {
        const switchAllow: Switch = event.target as Switch;
        this.manageAllowBatchOrderChecked(switchAllow.checked);
    }
}
